$.lui("comp", ".comp_career_branch_about_graph", function(selector) {
    selector.lib_chart();
});